import React from "react";

import { templates } from "@reactivated";

import { NPSSurvey } from "../apps/checkout/NPSSurvey";

export const Template = (
    props: templates.NPSSurveyTemplate,
): React.JSX.Element => {
    return <NPSSurvey {...props} />;
};
